<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="partners/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="partners/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            textpicker-namespace="partners/text"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-filepicker
            v-if="[5, 6].includes(getProp('tecpage.user.modules.' + moduleId + '.layout.type'))"
            label="Bild"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.image'"
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="false"
        ></app-filepicker>

        <app-link
            v-if="hasPackageBasic"
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>

        <app-list
            :data-source="'deha.user.misc.partners'"
            :data-preset="false"
            :data-name="'data.name'"
            :list-subpage="'Partners'"
            :allow-individual="true"
            :label="'Partner'"
        ></app-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import List from '@/components/fields/complex/List.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R032'),
            removeText: this.$helpers.uiText('R033'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link,
        'app-list': List,
        'app-filepicker': Filepicker
    }
};
</script>
